import backendAPIClient from '../apiClient';

export default function getFronteggTokenData() {
    return backendAPIClient.get('token').then((result) => result.data);
}
